import React from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import ReviewParticulars from '../../modules/subject/components/ReviewParticulars';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';

interface ReviewParticularsPageProps {
  routeSteps: { label: string }[];
  isGroup?: boolean;
}

const ReviewParticularsPage = ({ routeSteps, isGroup = false }: ReviewParticularsPageProps) => {
  const { t } = useTranslation();

  const title: string = isGroup
    ? t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')
    : t('amendment->>SubjectAmendment.Subject Amendment');
  const activeStep: number = isGroup ? 4 : 3;
  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        {isGroup && <ExamTypeUuidDisplay />}
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <ReviewParticulars isGroup={isGroup} />
    </>
  );
};

export default ReviewParticularsPage;
